import { render, staticRenderFns } from "./ReviewWidget.vue?vue&type=template&id=7d00de3c&scoped=true"
import script from "./ReviewWidget.vue?vue&type=script&lang=js"
export * from "./ReviewWidget.vue?vue&type=script&lang=js"
import style0 from "./ReviewWidget.vue?vue&type=style&index=0&id=7d00de3c&prod&lang=scss&scoped=true"
import style1 from "./ReviewWidget.vue?vue&type=style&index=1&id=7d00de3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d00de3c",
  null
  
)

export default component.exports